// // src/components/ProtectedRoute.jsx
// import { Navigate } from "react-router-dom";
// import { jwtDecode } from 'jwt-decode'; // ✅ Correct


// const ProtectedRoute = ({ children, requiredRole }) => {
//   const token = localStorage.getItem("jwt"); // Get the token from localStorage
//   console.log(token,children, requiredRole);
//   if (!token) {
//     // If token is missing, redirect to sign-in
//     return <Navigate to="/sign-in" replace />;
//   }

//   try {
//     const decoded = jwtDecode(token); // Decode token to extract role
// console.log(decoded);
//     // If role is required, check if user's role matches
//     if (
//       requiredRole &&
//       !requiredRole.includes(decoded.role) // Allow multiple roles
//     ) {
//       return <Navigate to="/" replace />;
//     }

//     return children; // User is authorized
//   } catch (error) {
//     // Token is invalid
//     console.error("Token decoding failed:", error);
//     return <Navigate to="/sign-in" replace />;
//   }
// };

// export default ProtectedRoute;








// src/Routers/ProtectedRoute/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem("jwt");

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    console.log (decoded)
    if (requiredRole && !requiredRole.includes(decoded.role)) {
      return <Navigate to="/access-denied" replace />;
    } 

    return children;
  } catch (error) {
    console.error("Token decoding failed:", error);
    return <Navigate to="/sign-in" replace />;
  }
};

export default ProtectedRoute;
